import getConfig from 'next/config';
import dynamic from 'next/dynamic';

import type { ProductCarouselRecommendationsSectionProps } from 'src/components/sections/ProductCarouselRecommendationsSection/ProductCarouselRecommendationsSection';
import type { SectionRenderer } from 'src/types/Section';
import type { AsyncTransformer } from 'src/types/Transformer';
import type { ProductCarouselRecommendationsContentSection } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<ProductCarouselRecommendationsSectionProps> =
  dynamic<ProductCarouselRecommendationsSectionProps>(() =>
    import(
      'src/components/sections/ProductCarouselRecommendationsSection/ProductCarouselRecommendationsSection'
    ).then((mod) => mod.ProductCarouselRecommendationsSection),
  );

export const transformer: AsyncTransformer<
  ProductCarouselRecommendationsContentSection,
  ProductCarouselRecommendationsSectionProps
> = async ({ _metadata, tracking_title }, { pageMetadata, positionMetadata }) => {
  const { HOME_RECOMMENDATIONS_DEFAULT_SERVING_CONFIG } = getConfig().publicRuntimeConfig;
  if (!HOME_RECOMMENDATIONS_DEFAULT_SERVING_CONFIG) {
    throw new Error('HOME_RECOMMENDATIONS_DEFAULT_SERVING_CONFIG is not set');
  }

  return {
    uid: _metadata.uid,
    props: {
      currency: pageMetadata.currency,
      /* Travels with the currency because both scope the same recommendations
         request. Undefined is a real value here: what an unknown zone means is
         decided where the request is built, not twice over. */
      deliveryZone: pageMetadata.deliveryZone,
      trackingTitle: tracking_title,
      trackingPosition: positionMetadata.position,
      servingConfig: HOME_RECOMMENDATIONS_DEFAULT_SERVING_CONFIG,
    },
  };
};
